import { getMessages } from '../../../../../../../../store/constants';

export const NOTIFICATIONS_LIST_LABEL_TEXT = getMessages().getText('label.notifications_before_due_date.text');
